(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE={id:"57e6de8d609ec20b10ba0b62cdb56a424ab0f75a-tops"};


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/webpack-plugin/src/sentry-webpack.module.js
// module id = 1019
// module chunks = 0